export enum Language {
  cs = 1,
  en = 2,
}
